import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import {
  Button,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

export interface AddCustomParameterProps {
  cancelButtonLabel: string;
  saveButtonLabel: string;
  onCancel?: () => void; // 👈 to discard the form

  onSave?: (param: { name: string; description: string }) => void;
}

const useStyles = makeStyles()({
  mainContainer: {
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    padding: '16px 12px',
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    gap: '12px',
    justifyContent: 'flex-end',
  },
});
export const AddCustomParameter: React.FC<AddCustomParameterProps> = ({
  cancelButtonLabel,
  saveButtonLabel,
  onCancel,
  onSave,
}) => {
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const { classes } = useStyles();
  const handleSave = () => {
    if (!name.trim()) {
      alert('Name is required');
      return;
    }

    const newParam = {
      name: name.trim(),
      description: description.trim(),
    };

    onSave?.(newParam);
    setName('');
    setDescription('');
  };

  return (
    <Grid className={classes.mainContainer}>
      <Grid>
        <ReportCreateNewLabelField
          label="Name"
          width="100%"
          component={
            <TextField
              value={name}
              fullWidth
              height="36px"
              onChange={(e: any) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          }
        />
        <ReportCreateNewLabelField
          label="Description (Optional)"
          width="100%"
          component={
            <TextField
              value={description}
              fullWidth
              height="36px"
              onChange={(e: any) => setDescription(e.target.value)}
              placeholder="Enter Description"
            />
          }
        />
      </Grid>
      <Grid className={classes.buttonContainer}>
        <Button
          label={cancelButtonLabel}
          width="auto"
          variant="text"
          onClick={onCancel}
        />
        <Button
          label={saveButtonLabel}
          width="auto"
          variant="contained"
          color="primary"
          onClick={() => {
            // You can add validation here if needed
            handleSave();
          }}
        />
      </Grid>
    </Grid>
  );
};
